import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import { RootLayout } from "@/layouts/RootLayout";
import { AppLayout } from "@/layouts/AppLayout";

// Lazy load pages for code splitting
const HomePage = lazy(() => import("@/pages/HomePage"));
const MyBinsPage = lazy(() => import("@/pages/MyBinsPage"));
const BinListViewPage = lazy(() => import("@/pages/BinListViewPage"));
const DiscoverPage = lazy(() => import("@/pages/DiscoverPage"));
const ToolsPage = lazy(() => import("@/pages/ToolsPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const ProfilePage = lazy(() => import("@/pages/ProfilePage"));

// Loading component for suspense fallback
const PageLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center">
    <div className="animate-pulse">Loading...</div>
  </div>
);

// Wrapper component to handle suspense
const LazyPage = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader />}>{children}</Suspense>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: (
      <Suspense fallback={<PageLoader />}>
        <NotFoundPage />
      </Suspense>
    ),
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: (
              <LazyPage>
                <HomePage />
              </LazyPage>
            ),
          },
          {
            path: "my-bins",
            element: (
              <LazyPage>
                <MyBinsPage />
              </LazyPage>
            ),
          },
          {
            path: "list/:id",
            element: (
              <LazyPage>
                <BinListViewPage />
              </LazyPage>
            ),
          },
          {
            path: "discover",
            element: (
              <LazyPage>
                <DiscoverPage />
              </LazyPage>
            ),
          },
          {
            path: "tools",
            element: (
              <LazyPage>
                <ToolsPage />
              </LazyPage>
            ),
          },
          {
            path: "login",
            element: (
              <LazyPage>
                <LoginPage />
              </LazyPage>
            ),
          },
          {
            path: "profile/:username",
            element: (
              <LazyPage>
                <ProfilePage />
              </LazyPage>
            ),
          },
        ],
      },
    ],
  },
]);
